var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Inject } from '../Application';
import { Constants } from '../Contract';
import { ErrorCodes, ExceptionHandlerClass } from '../System/Aop';
import { AliasBehavior } from './Behaviors';
var TypeService = (function () {
    function TypeService(inject) {
        if (inject === void 0) { inject = null; }
        this.inject = inject || Inject.Instance;
        this.modelResolver = this.inject.resolve(Constants.ModelResolver);
        this.behaviorEnabled = false;
    }
    TypeService.prototype.getAlias = function (model, alias) {
        return this.aliases[model.toString()][alias][0];
    };
    TypeService.prototype.setAliases = function (aliases) {
        this.aliases = aliases;
    };
    TypeService.prototype.init = function (data) {
        this.enableAliasBehavior(data.DefaultsAndAlias);
        this.typesInfo = data.TypesInfo;
    };
    TypeService.prototype.setTypes = function (typesInfo) {
        this.typesInfo = typesInfo;
    };
    TypeService.prototype.getTypeInfo = function (typeId) {
        return this.typesInfo[typeId];
    };
    TypeService.prototype.enableAliasBehavior = function (aliasesInfo) {
        if (aliasesInfo && !this.behaviorEnabled) {
            var firstKey = Object.keys(aliasesInfo)[0];
            if (aliasesInfo[firstKey] !== undefined && Object.keys(aliasesInfo[firstKey]).length > 0) {
                this.modelResolver.registerBehavior(new AliasBehavior());
                this.aliases = aliasesInfo;
                this.behaviorEnabled = true;
            }
        }
    };
    TypeService = __decorate([
        ExceptionHandlerClass(ErrorCodes.ClientCore),
        __metadata("design:paramtypes", [Object])
    ], TypeService);
    return TypeService;
}());
export { TypeService };
